export const externalUrlGroupsTranslation = {

  // section title
  external_urls: 9429,

  // search
  search: 7345,
  search_hits: 7474,
  search_no_external_urls: 9467,

  // messages
  no_access_to_external_urls: 9417,
  external_url_deleted: 9466,
  external_url_updated: 9464,
  external_url_created: 9465,

  // list item
  disabled: 5251,
  delete_external_url_title: 9461,
  column_url_template: 9410,
  column_description: 9411,
  sequence: 9442,

  // confirmation
  delete_confirmation: 9218,
  cancel: 9432,

  // prompt unsaved
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // form messages
  external_url_validation_error: 8206,
  saving_external_url_group: 9459,
  deleting_external_url_group: 9460,

  // form header
  new_external_url_group: 9439,
  save: 9433,
  add_new: 6943,
  delete: 9434,
  delete_external_url_group: 9461,
  preview_title: 9556,
  preview_close: 9557,

  // form tabs
  switch_to_scroll: 7977,
  switch_to_tab: 7978,

  // sections
  details: 8044,
  descriptions_and_translations: 8391,

  // access policy
  access_policy_title: 9440,
  add_access_policy: 9447,
  no_access_policy: 9457,
  access_policy_operation_info: 9454,
  application_label: 9443,
  operation_label: 9444,
  info_label: 9455,

  // external urls
  external_urls_title: 9441,
  external_url_manage_url: 9453,
  external_url_template: 9446,
  external_url_long_description: 9552,
  external_url_long_description_info: 9553,
  external_url_add_url: 9450,
  external_url_add_new_url: 9456,
  external_url_add_option: 9462,
  external_url_move_up_option: 9451,
  external_url_move_down_option: 9452,
  external_url_preview_title: 9598,
  external_url_preview_subtitle: 9599,

  // language
  translations_header: 8364,
  show_translations: 8393,
  description: 7278,
  copy_description_to_all: 8386,
  copied_description_to_all: 8388,
  long_description_title: 9437,
  copy_long_description_to_all: 9438,
  copied_long_description_to_all: 9458,

  // validation
  must_be_filled_out: 5949,
  done: 9463,
  remove: 9448,
  remove_all: 9449
};

export type ExternalUrlGroupsTranslation = {
  readonly [T in keyof typeof externalUrlGroupsTranslation]: string
};
